import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { CounterpartyTypeEnum } from "@rmp/core/types/CounterpartyTypeEnum";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import RmpDropzone from "@rmp/core/components/dropzone/RmpDropzone.vue";
import RmpFormCol from "@rmp/core/components/form/RmpFormCol.vue";
import { STORAGE_APPOINTMENT_HEAD_ORDER, STORAGE_INN_NAMESPACE } from "@rmp/core/constants/storage";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessDocumentsStepStore } from "@rmp/id/stores/masterAccountAccess/steps/documents";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDocumentsStep',
  setup(__props) {

const { colors } = useColors();

const { tc } = useI18n();

const selectCounterpartyStepStore = useMasterAccountAccessSelectCounterpartyStepStore();

const { counterpartyType } = useMasterAccountAccessSelectCounterpartyStepStore();
const useStore = useMasterAccountAccessDocumentsStepStore;
const store = useStore();

let { documents } = storeToRefs(store);

const { processFile, removeFile } = useStore();

const confirmRightPerformActionsText = computed(() => {
	const legalEntityText = tc("common.masterAccountAccessDocumentsStep.legalEntity");
	const legalPersonText = tc("common.masterAccountAccessDocumentsStep.legalPerson");
	const isLegalEntity = CounterpartyTypeEnum.LEGAL_ENTITY === selectCounterpartyStepStore.counterpartyType;
	
	const counterpartyText = isLegalEntity ? legalEntityText : legalPersonText;
	
	return `${tc("common.masterAccountAccessDocumentsStep.toConfirmRightPerformActionsOnBehalfOf")} ${counterpartyText}, 
	${tc("common.masterAccountAccessDocumentsStep.attachDocumentsListBelow")}.`;
});

const addFile = async (file: any, docType: string) => {
	await processFile({ fileId: file.id, docType });
};
const deleteFile = (docType: string) => {
	removeFile(docType);
};

const { initialized } = usePage({ useStore });

return { __sfc: true,colors, tc, selectCounterpartyStepStore, counterpartyType, useStore, store, documents, processFile, removeFile, confirmRightPerformActionsText, addFile, deleteFile, initialized, RmpText, CounterpartyTypeEnum, RmpMasterAccountAccessApplicationBaseStep, RmpDropzone, RmpFormCol, STORAGE_APPOINTMENT_HEAD_ORDER, STORAGE_INN_NAMESPACE }
}

})